import { useEffect } from 'react';

type SeoConfig = {
  title: string;
  description: string;
  keywords: string;
  image?: string;
  type?: 'website' | 'article';
};

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

export function useSeo({ title, description, keywords, image, type = 'website' }: SeoConfig) {
  useEffect(() => {
    document.title = title;
    setMeta('name', 'description', description);
    setMeta('name', 'keywords', keywords);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:type', type);
    if (image) {
      setMeta('property', 'og:image', image);
    }

    const basePath = __BASE_PATH__.split('/').filter(Boolean).join('/');
    const prefix = basePath ? `/${basePath}` : '';
    const canonicalHref = `${window.location.origin}${prefix}${window.location.pathname.replace(prefix, '')}`;
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalHref);
  }, [title, description, keywords, image, type]);
}